// Script to hide the Klaviyo teaser when the sticky ATC bar is visible
document.addEventListener("DOMContentLoaded", () => {
  const stickyAtcBar = document.querySelector('.sticky-atc-bar');
  const klaviyoTeaserSelector = '.kl-teaser-S5N3id';
  let klaviyoTeaser = null;
  let stickyBarObserver = null;
  let bodyObserver = null;

  // Function to check and toggle the teaser's visibility
  function toggleTeaserVisibility() {
    if (!klaviyoTeaser || !stickyAtcBar) return;

    try {
      if (stickyAtcBar.classList.contains('hidden')) {
        klaviyoTeaser.style.display = 'block';
      } else {
        klaviyoTeaser.style.display = 'none';
      }
    } catch (e) {
      console.warn('Error toggling Klaviyo teaser visibility:', e);
    }
  }

  // Function to find and cache the Klaviyo teaser element
  function findKlaviyoTeaser() {
    if (!klaviyoTeaser) {
      klaviyoTeaser = document.querySelector(klaviyoTeaserSelector);
      if (klaviyoTeaser && bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
    }
    return klaviyoTeaser;
  }

  if (stickyAtcBar) {
    // Initial check on page load
    if (findKlaviyoTeaser()) {
      toggleTeaserVisibility();
    }

    // Observer 1: Watch for changes to the sticky bar's class list
    stickyBarObserver = new MutationObserver(toggleTeaserVisibility);
    stickyBarObserver.observe(stickyAtcBar, { attributes: true, attributeFilter: ['class'] });

    // Observer 2: Watch for the Klaviyo teaser to be added to the DOM
    // Only watch body children, not entire subtree for better performance
    bodyObserver = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let j = 0; j < mutation.addedNodes.length; j++) {
            const node = mutation.addedNodes[j];
            // Check if the node itself matches or contains the selector
            if (node.nodeType === 1) { 
              // Element node
              if (node.matches && node.matches(klaviyoTeaserSelector)) {
                klaviyoTeaser = node;
                toggleTeaserVisibility();
                if (bodyObserver) {
                  bodyObserver.disconnect();
                  bodyObserver = null;
                }
                return;
              }
              if (node.querySelector && node.querySelector(klaviyoTeaserSelector)) {
                klaviyoTeaser = node.querySelector(klaviyoTeaserSelector);
                toggleTeaserVisibility();
                if (bodyObserver) {
                  bodyObserver.disconnect();
                  bodyObserver = null;
                }
                return;
              }
            }
          }
        }
      }
    });

    // Start observing the body for child list changes (only direct children for better performance)
    bodyObserver.observe(document.body, { childList: true, subtree: false });

    // Fallback: check periodically if teaser hasn't been found after 5 seconds
    setTimeout(() => {
      if (!klaviyoTeaser && bodyObserver) {
        findKlaviyoTeaser();
        if (klaviyoTeaser) {
          toggleTeaserVisibility();
          bodyObserver.disconnect();
          bodyObserver = null;
        }
      }
    }, 5000);
  }
});

(function () {
  var TRIGGER_HASH = '#glowface-vip';
  var FORM_ID = 'VeFfmU';
  var MAX_RETRIES = 50; // Maximum 15 seconds (50 * 300ms)
  var RETRY_DELAY = 300;

  function openGlowfaceForm() {
    var retryCount = 0;

    function tryTrigger() {
      if (window._klOnsite && typeof window._klOnsite.push === 'function') {
        window._klOnsite.push(['openForm', FORM_ID]);
        console.log('🟢 Klaviyo form triggered.');
      } else {
        retryCount++;
        if (retryCount < MAX_RETRIES) {
          console.log('⏳ Waiting for _klOnsite... (' + retryCount + '/' + MAX_RETRIES + ')');
          setTimeout(tryTrigger, RETRY_DELAY);
        } else {
          console.warn('⚠️ Klaviyo form failed to load after maximum retries.');
        }
      }
    }
    tryTrigger();
  }

  function maybeOpenFromHash() {
    if (window.location.hash === TRIGGER_HASH) {
      console.log('🔁 Opening form from hash...');
      openGlowfaceForm();
    }
  }

  // Trigger on click for links/buttons
  function handleClick(e) {
    var link = e.target.closest('a[href="' + TRIGGER_HASH + '"], button[href="' + TRIGGER_HASH + '"]');
    if (link) {
      e.preventDefault();
      console.log('🖱️ Glowface link clicked.');
      openGlowfaceForm();
    }
  }

  document.addEventListener('click', handleClick);

  // Trigger on hash change or page load
  window.addEventListener('hashchange', maybeOpenFromHash);
  document.addEventListener('DOMContentLoaded', maybeOpenFromHash);
})();

document.addEventListener('DOMContentLoaded', function () {
  const quickCartSelector = '.quick-cart__wrapper';
  const quickCart = document.querySelector(quickCartSelector);

  if (!quickCart) return; // Exit early if cart doesn't exist

  let formShown = false;
  let timeoutId = null;

  const cartObserver = new MutationObserver(function () {
    // Only check if form hasn't been shown yet
    if (formShown) return;

    // Check if the cart has the 'active' class
    if (quickCart.classList.contains('active')) {
      // Clear any existing timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Wait 10 seconds before showing the form
      timeoutId = setTimeout(function () {
        if (!formShown && window._klOnsite) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'TdPQvY']);
          formShown = true;
          cartObserver.disconnect(); // Disconnect after showing form
        }
      }, 10000);
    } else {
      // Cart closed, clear timeout if it exists
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  });

  // Only observe the cart element itself, not the entire body
  cartObserver.observe(quickCart, { attributes: true, attributeFilter: ['class'] });
});

(function hideHCaptchaBadge() {
  var BADGE_ID = 'shop-hcaptcha-badge-container';
  var badgeFound = false;
  var observer = null;

  function hide() {
    var el = document.getElementById(BADGE_ID);
    if (el) {
      el.style.cssText = `
        position:absolute !important;
        left:-9999px !important;
        top:auto !important;
        width:1px !important;
        height:1px !important;
        overflow:hidden !important;
        pointer-events:none !important;
      `;
      badgeFound = true;
    }
  }

  hide(); // hide immediately

  // Only watch if badge wasn't found initially
  if (!badgeFound) {
    // Watch for re-injection - optimize by watching body children only
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            // Check if the added node is the badge or contains it
            if (node.nodeType === 1) {
              // Element node
              if (node.id === BADGE_ID || (node.querySelector && node.querySelector('#' + BADGE_ID))) {
                hide();
                // If badge is found, we can optionally disconnect after a delay
                // to allow for potential re-injections, but reduce observation scope
                return;
              }
            }
          }
        }
      }
    });

    // Watch body children only (not entire subtree) for better performance
    observer.observe(document.body, { childList: true, subtree: false });

    // Fallback: check periodically for badge that might be injected deeper
    var checkInterval = setInterval(function () {
      if (!badgeFound) {
        hide();
        if (badgeFound && observer) {
          // Badge found, but keep observer running for potential re-injections
          // with reduced scope
          observer.disconnect();
          observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
              var mutation = mutations[i];
              if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                hide();
                break;
              }
            }
          });
          observer.observe(document.body, { childList: true, subtree: false });
        }
      }
    }, 2000);

    // Stop checking after 30 seconds if badge still not found
    setTimeout(function () {
      clearInterval(checkInterval);
    }, 30000);
  }
})();
